import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const FruitPlants = () => {
    const [fruitPlants, setFruitPlants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    // Fetch fruit plants from backend
    useEffect(() => {
        const fetchFruitPlants = async () => {
            try {
                setLoading(true);
                // Fetch fruit plants - using category=fruit (maps to 'Fruit Plants' in backend)
                const response = await fetch('http://localhost:5000/api/products?category=fruit&limit=12');
                
                if (!response.ok) {
                    throw new Error('Failed to fetch fruit plants');
                }
                
                const data = await response.json();
                console.log('Fruit plants:', data);
                
                if (data.success && data.data) {
                    setFruitPlants(data.data);
                } else {
                    setFruitPlants([]);
                }
            } catch (err) {
                console.error('Error fetching fruit plants:', err);
                setError('Failed to load fruit plants. Please make sure the backend server is running.');
            } finally {
                setLoading(false);
            }
        };

        fetchFruitPlants();
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: fruitPlants.length > 6,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    // Format review count (e.g., 2100 -> 2.1k)
    const formatReviewCount = (count) => {
        if (count >= 1000) {
            return `${(count / 1000).toFixed(1)}k`;
        }
        return count;
    };

    if (loading) {
        return (
            <section className="fruit-plants py-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Fruit Plants</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link
                                    to="/shop?category=Fruit Plants"
                                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                                >
                                    All Categories
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading fruit plants...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="fruit-plants py-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Fruit Plants</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link
                                    to="/shop?category=Fruit Plants"
                                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                                >
                                    All Categories
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="alert alert-danger text-center" role="alert">
                        {error}
                    </div>
                </div>
            </section>
        );
    }

    if (fruitPlants.length === 0) {
        return (
            <section className="fruit-plants py-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Fruit Plants</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link
                                    to="/shop?category=Fruit Plants"
                                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                                >
                                    All Categories
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="alert alert-info text-center" role="alert">
                        No fruit plants available at the moment. Please check back later!
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="fruit-plants py-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Fruit Plants</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop?category=Fruit Plants"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Categories
                            </Link>
                        </div>
                    </div>
                </div>
                {fruitPlants.length > 5 ? (
                    <div className="fruit-plants__slider arrow-style-two">
                        <Slider {...settings}>
                            {fruitPlants.map((plant) => (
                                <div key={plant._id}>
                                    <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                        {plant.badge && (
                                            <span className={`product-card__badge ${plant.badgeColor} px-8 py-4 text-sm text-white`}>
                                                {plant.badge}
                                            </span>
                                        )}
                                        <Link
                                            to={`/product-details/${plant._id}`}
                                            className="product-card__thumb flex-center"
                                        >
                                            <img 
                                                src={plant.image || 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=200&h=200&fit=crop'} 
                                                alt={plant.name}
                                                onError={(e) => {
                                                    e.target.src = 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=200&h=200&fit=crop';
                                                }}
                                                style={{ width: '100%', height: 'auto' }}
                                            />
                                        </Link>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">{plant.rating || 4.7}</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">({formatReviewCount(plant.reviewsCount || 0)})</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                <Link to={`/product-details/${plant._id}`} className="link text-line-2">
                                                    {plant.name}
                                                </Link>
                                            </h6>
                                            <div className="flex-align gap-4">
                                                <span className="text-main-600 text-md d-flex">
                                                    <i className="ph-fill ph-storefront" />
                                                </span>
                                                <span className="text-gray-500 text-xs">
                                                    By {plant.vendorName || 'Paudhawala Nursery'}
                                                </span>
                                            </div>
                                            <div className="flex-between gap-8 mt-24 flex-wrap">
                                                <div className="product-card__price">
                                                    {plant.originalPrice && plant.originalPrice > plant.price && (
                                                        <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                            ₹{plant.originalPrice.toFixed(2)}
                                                        </span>
                                                    )}
                                                    <span className="text-heading text-md fw-semibold ">
                                                        ₹{plant.price.toFixed(2)} <span className="text-gray-500 fw-normal">/{plant.unit || 'Plant'}</span>{" "}
                                                    </span>
                                                </div>
                                                <Link
                                                    to="/cart"
                                                    className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                                                >
                                                    Add <i className="ph ph-shopping-cart" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                ) : (
                    <div className="row g-4">
                        {fruitPlants.map((plant) => (
                            <div key={plant._id} className="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 h-100">
                                    {plant.badge && (
                                        <span className={`product-card__badge ${plant.badgeColor} px-8 py-4 text-sm text-white`}>
                                            {plant.badge}
                                        </span>
                                    )}
                                    <Link
                                        to={`/product-details/${plant._id}`}
                                        className="product-card__thumb flex-center"
                                    >
                                        <img 
                                            src={plant.image || 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=200&h=200&fit=crop'} 
                                            alt={plant.name}
                                            onError={(e) => {
                                                e.target.src = 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=200&h=200&fit=crop';
                                            }}
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </Link>
                                    <div className="product-card__content mt-12">
                                        <div className="flex-align gap-6">
                                            <span className="text-xs fw-bold text-gray-500">{plant.rating || 4.7}</span>
                                            <span className="text-15 fw-bold text-warning-600 d-flex">
                                                <i className="ph-fill ph-star" />
                                            </span>
                                            <span className="text-xs fw-bold text-gray-500">({formatReviewCount(plant.reviewsCount || 0)})</span>
                                        </div>
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                            <Link to={`/product-details/${plant._id}`} className="link text-line-2">
                                                {plant.name}
                                            </Link>
                                        </h6>
                                        <div className="flex-align gap-4">
                                            <span className="text-main-600 text-md d-flex">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-gray-500 text-xs">
                                                By {plant.vendorName || 'Paudhawala Nursery'}
                                            </span>
                                        </div>
                                        <div className="flex-between gap-8 mt-24 flex-wrap">
                                            <div className="product-card__price">
                                                {plant.originalPrice && plant.originalPrice > plant.price && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                        ₹{plant.originalPrice.toFixed(2)}
                                                    </span>
                                                )}
                                                <span className="text-heading text-md fw-semibold ">
                                                    ₹{plant.price.toFixed(2)} <span className="text-gray-500 fw-normal">/{plant.unit || 'Plant'}</span>{" "}
                                                </span>
                                            </div>
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                                            >
                                                Add <i className="ph ph-shopping-cart" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    )
}

export default FruitPlants;